import React, { useEffect } from 'react';
import './BlackJackView.css';

export const BlackJackView = ({
    seatsTaken,
    showGradient,
    betBehind,
}) => {
    const seatsTakenValidated = seatsTaken || [];
    const people = renderPersons(seatsTakenValidated, betBehind);

    // hide gradient background for fields block in case nothing rendered
    useEffect(() => {
        showGradient(!(seatsTakenValidated.length <= 3 || !people));
    }, [seatsTakenValidated, people]);

    if (seatsTakenValidated.length <= 3 || !people) {
        return null;
    }

    return (
        <div className="game-type__blackjack blackjack-game">
            <div className="blackjack-game__people blackjack-people">
                {people}
            </div>
        </div>
    );
};

/**
 * Depending on seats taken - renders a predefined sets of people icons with fixed places
 */
function renderPersons(seatsTaken = [], betBehind = false) {
    let iconClassMap = [];

    if (seatsTaken.length === 4) {
        iconClassMap = new Array(7).fill('taken');
        iconClassMap[2] = 'free';
        iconClassMap[3] = 'free';
        iconClassMap[4] = 'free';
    }

    if (seatsTaken.length === 5) {
        iconClassMap = new Array(7).fill('taken');
        iconClassMap[3] = 'free';
        iconClassMap[4] = 'free';
    }

    if (seatsTaken.length === 6) {
        iconClassMap = new Array(7).fill('taken');
        iconClassMap[2] = 'last';
    }

    if (!betBehind && seatsTaken.length === 7) {
        iconClassMap = new Array(7).fill('occupied');
    }

    if (iconClassMap.length === 0) {
        return null;
    }

    return iconClassMap.map((iconClass, index) => (
        <div
            className={`blackjack-people__icon blackjack-people__icon--${iconClass}`}
            key={index}
        />
    ));
}
